<div class="box" [class.invalid]="invalid()" [class.disabled]="isDisabled()">
  @if (isEmpty()) {
    @if (!isDisabled()) {
      <div class="placeholder">{{ placeholder() | translate }}</div>
    }
  } @else {
    <div class="selected-options">
      @for (option of selectedOptions(); track option.value) {
        <div [class.selected-option]="multiple()">{{ option.label }}</div>
      }
    </div>
  }

  <smw-icon [icon]="carretIcon" />
</div>
@if (displayOptions()) {
  <div class="options">
    <ng-content />
  </div>
}
